var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prepend-top-default"},[_c('p',[_vm._t("default")],2),_vm._v(" "),_c('resizable-chart-container',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var width = ref.width;
return _c('gl-area-chart',{attrs:{"width":width,"height":_vm.$options.chartContainerHeight,"data":_vm.chartData,"include-legend-avg-max":false,"option":_vm.$options.areaChartOptions}})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }